<template lang="html">
  <v-form ref="form" lazy-validation>
    <v-card>
      <v-card-title>
        {{ $tc('title.alterar_dados_sensiveis', 1) }}
      </v-card-title>
      <v-container grid-list-xl fluid v-show="isPaginaCarregada">
        <v-row id="dados-sensiveis">
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              :label="`${$t('label.email')} *`"
              ref="email"
              v-model="usuario.email"
              required
              :rules="[rules.requiredText, rules.isEmailValid]"
              maxlength="150"
              autocomplete="null"
              clearable
              counter>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              :label="`${$t('label.nome')} *`"
              v-model="usuario.nome"
              autocomplete="null"
              required
              :rules="[rules.requiredText]"
              maxlength="100"
              counter
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              :label="$t('label.sobrenome')"
              v-model="usuario.sobrenome"
              autocomplete="null"
              maxlength="150"
              counter
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              :label="`${$t('label.cargo')} *`"
              v-model="usuario.cargo"
              maxlength="50"
              counter
              required
              :rules="[rules.requiredText]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              :label="`${$t('label.documento')} *`"
              v-model="usuario.documento"
              maxlength="50"
              counter
              required
              :rules="[rules.requiredText]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <tenant-usuario-logado-list v-if="tenantsUsuario" :tenants="tenantsUsuario"></tenant-usuario-logado-list>
          </v-col>
          <v-col cols="12">
            <v-text-field
              :label="`${$t('label.justificativa')} *`"
              v-model="justificativaEdicao"
              maxlength="300"
              counter
              required
              :rules="[rules.requiredText]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="openCancelarDialog">{{ $t('label.cancelar') }}</v-btn>
        <v-btn @click.native="openSaveDialog" color="primary">{{ $t('label.salvar') }}</v-btn>
      </v-card-actions>
    </v-card>
    <confirm
      ref="confirmDialog"
      max-width="600px"
      style="white-space: pre-line !important;"
      :message="dialog.content"
      :persistent="true"
      @agree="dialog.action">
    </confirm>
    <confirm
      ref="cancelarDialog" :title="$t('title.atencao')"
      :message="$t('message.tem_certeza_cancelar')"
      @agree="cancel">
    </confirm>
  </v-form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  forceHideLoading,
  forceLoading,
} from '@/common/functions/loading';
import Usuario from '@/spa/usuario/Usuario';
import Confirm from '@/shared-components/dialog/Confirm';
import { copyObject } from '@/common/functions/helpers';
import TenantUsuarioLogadoList from '../../shared-components/tenant/TenantUsuarioLogadoList';

export default {
  name: 'UsuarioFornecedorDadosSensiveis',
  components: {
    TenantUsuarioLogadoList,
    Confirm,
  },
  computed: {
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    ...mapGetters('roles', [
      'getTenantId',
    ]),
    isAprovadorAutorizado() {
      return !this.usuario.indUsuarioExternoMaster;
    },
  },
  data() {
    return {
      tenantsUsuario: [],
      userLogadoInfo: null,
      isPaginaCarregada: false,
      usuario: new Usuario(null, 'FORNECEDOR'),
      resourceMetadado: this.$api.metadado(this.$resource),
      extensaoResources: this.$api.extensao(this.$resource),
      idUsuario: null,
      usuarioResource: this.$api.usuario(this.$resource),
      justificativaEdicao: '',
      usuarioSemEdicao: {},
      emailReg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredText: (value) => (!!value && !!value.trim()) || this.$t('message.campo_obrigatorio'),
        isEmailValid: (value) => this.emailReg.test(value) || this.$t('message.campo_obrigatorio_ou_invalido'),
      },
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao_alerta'),
        content: this.$t('message.alteracao_dados_sensiveis'),
        action() {},
      },
    };
  },
  methods: {
    carregarUsuario(id) {
      this.usuarioResource.buscar({ id })
        .then((res) => {
          this.editar(res.body);
          this.tenantsUsuario = res.body.tenant?.split(',').map((t) => t.trim()) ?? [];
          forceHideLoading();
        })
        .catch((err) => {
          this.$error(this, err);
          forceHideLoading();
        });
    },
    openCancelarDialog() {
      this.$refs.cancelarDialog.open();
    },
    editar(usuario) {
      this.usuario = new Usuario();
      this.usuario.construirAPartirDaConsultaCompleta({ ...usuario });
      this.buscarExtensoes(this.usuario.idGrupoFornecedor);
      this.usuarioSemEdicao = copyObject(usuario);
      this.usuario.tenant = this.getTenantId;
    },
    setarPaginaCarregada(indPaginaCarregada) {
      this.isPaginaCarregada = indPaginaCarregada;
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.action = this.save;
      this.$refs.confirmDialog.open();
    },
    save() {
      this.aplicarTrimCamposTexto();
      this.usuario.statusFluxo = 'AGUARDANDO_APROVACAO';
      this.requestAtualizar(this.usuario, this.usuarioResource.atualizar);
    },
    cancel() {
      this.$router.push({ name: 'usuario-fornecedor' });
    },
    requestAtualizar(object, resource) {
      resource({ id: object.id }, object)
        .then(() => {
          if (!this.isAprovadorAutorizado) {
            this.enviaEmailNotificacaoEdicaoDadosSensiveis();
          }
          this.salvarJustificativaAlteracaoDadosSensiveis();
          forceHideLoading();
          window.setTimeout(() => {
            this.$router.push({ name: 'usuario-fornecedor' });
            this.$toast(this.$t('message.atualizado_com_sucesso'));
          }, 500);
        })
        .catch((err) => {
          forceHideLoading();
          this.$toast(err.data.error);
        });
    },
    buscarExtensoes(idGrupoFornecedor = null) {
      const params = {
        idNivelExtensao: 3,
        indUsuarioExterno: true,
      };
      if (idGrupoFornecedor) {
        params.idExtensao = idGrupoFornecedor;
      }
      return this.extensaoResources.obter(params)
        .then((res) => {
          this.extensoes = res.data.resposta;
          if (this.extensoes.length === 1) {
            const [grupoForn] = this.extensoes;
            this.usuario.grupofornecedor = grupoForn;
            this.usuario.id_grupofornecedor = grupoForn.id;
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    ...mapActions('metadados', [
      'setUsuarioMetadado',
    ]),
    obterInfoUsuarioLogado() {
      this.usuarioResource.buscar({ id: this.usuarioLogado.id }).then((res) => {
        this.usuarioLogadoInfo = res.body;
      }).catch((err) => {
        this.$error(this, err);
      });
    },
    salvarJustificativaAlteracaoDadosSensiveis() {
      const params = {
        justificativa: this.justificativaEdicao,
        id_usuario_criacao: this.usuarioLogadoInfo.id,
        id_usuario_alterado: this.usuario.id,
        id_externo_usuario_criacao: this.usuarioLogadoInfo.idExterno,
        id_externo_usuario_alterado: this.usuario.idExterno,
        tabela_atualizacao: this.getTabelaAtualizacao(),
        tenant: this.chaveEmpresa.toLowerCase(),
      };
      this.usuarioResource.dadosSensiveisAlteracao({ params })
        .then(() => {})
        .catch((err) => {
          this.$error(this, err);
        });
    },
    enviaEmailNotificacaoEdicaoDadosSensiveis() {
      const params = {
        email_old: this.usuarioSemEdicao.email,
        email_new: this.usuario.email !== this.usuarioSemEdicao.email ? this.usuario.email : 'Sem alteração',
        documento_old: this.usuarioSemEdicao.documento,
        documento_new: this.usuario.documento !== this.usuarioSemEdicao.documento ? this.usuario.documento : 'Sem alteração',
        nome_old: this.usuarioSemEdicao.nome,
        nome_new: this.usuario.nome !== this.usuarioSemEdicao.nome ? this.usuario.nome : 'Sem alteração',
        sobrenome_old: this.usuarioSemEdicao.sobrenome,
        sobrenome_new: this.usuario.sobrenome !== this.usuarioSemEdicao.sobrenome ? this.usuario.sobrenome : 'Sem alteração',
        cargo_old: this.usuarioSemEdicao.cargo,
        cargo_new: this.usuario.cargo !== this.usuarioSemEdicao.cargo ? this.usuario.cargo : 'Sem alteração',
        login: this.usuario.nomUsuario,
        usuario_logado_email: this.usuarioLogado.email,
        justificativa: this.justificativaEdicao,
        usuario_logado_nome_sobrenome: '',
        data_alteracao: new Date().toLocaleString('pt-BR', { hour12: false }),
      };

      params.usuario_logado_nome_sobrenome = this.usuarioLogadoInfo.nomeSobrenome;
      this.usuarioResource.enviarEmailNotificacaoEdicaoDadosSensiveis({ params }).then(() => {})
        .catch((err) => {
          this.$error(this, err);
        });
    },
    popularMetadadosUsuario() {
      if (this.getUsuarioMetadado) {
        return;
      }
      this.setUsuarioMetadado({
        resource: this.resourceMetadado.listarUsuario,
      });
    },
    aplicarTrimCamposTexto() {
      this.usuario.email = this.usuario.email.trim();
      this.usuario.nome = this.usuario.nome.trim();
      if (this.usuario.matricula) {
        this.usuario.matricula = this.usuario.matricula.trim();
      }
      if (this.usuario.sobrenome) {
        this.usuario.sobrenome = this.usuario.sobrenome.trim();
      }
      if (this.usuario.cargo) {
        this.usuario.cargo = this.usuario.cargo.trim();
      }
      if (this.usuario.documento) {
        this.usuario.documento = this.usuario.documento.trim();
      }
    },
    getTabelaAtualizacao() {
      const original = this.usuarioSemEdicao;
      const atual = this.usuario;
      let indTabelaUsuario = false;
      let indTabelaUsuarioFornecedor = false;
      if (atual.email !== original.email || atual.nome !== original.nome || atual.sobrenome !== original.sobrenome) {
        indTabelaUsuario = true;
      }
      if (atual.documento !== original.documento || atual.cargo !== original.cargo) {
        indTabelaUsuarioFornecedor = true;
      }

      if (indTabelaUsuario && indTabelaUsuarioFornecedor) {
        return 'todas';
      }

      return indTabelaUsuario ? 'usuario' : 'usuario_fornecedor';
    },
  },
  mounted() {
    this.buscarExtensoes(this.usuario.idGrupoFornecedor);
    this.obterInfoUsuarioLogado();
  },
  beforeMount() {
    forceLoading();
    Promise.all([
      this.popularMetadadosUsuario(),
    ]).then(() => {
      if (this.$route.params.id) {
        this.idUsuario = parseInt(this.$route.params.id, 10);
        Promise.all([
          this.carregarUsuario(this.idUsuario),
        ]).then(() => this.setarPaginaCarregada(true));
      } else {
        this.setarPaginaCarregada(true);
        forceHideLoading();
      }
    });
  },
};
</script>
<style>
</style>
